import {
    LINE_LIST_REQUEST,
    LINE_LIST_SUCCESS,
    LINE_LIST_ERROR,
    LINE_DETAIL_REQUEST,
    LINE_DETAIL_SUCCESS,
    LINE_DETAIL_ERROR,
    LINE_NEW_REQUEST,
    LINE_NEW_SUCCESS,
    LINE_NEW_ERROR,
    LINE_UPDATE_REQUEST,
    LINE_UPDATE_SUCCESS,
    LINE_UPDATE_ERROR,
    LINE_TRIGGER_HIGHLIGHT,
} from '../../actions/actionTypes';

const initialState = {
    loading: false,
    detailLoading: false,
    triggerHighlight: false,
    closeModal: false,
    lineList:[],
    lineDetail: null,
    meta: [],
    error: ''
}

const lineConfigListReducer = (state = initialState, action) => {
    switch (action.type) {
        case LINE_LIST_REQUEST:
            return {
                ...state,
                loading: true
            }
        case LINE_LIST_SUCCESS:
            return {
                ...state,
                loading: false,
                lineList: action.payload.lineList,
                meta: action.payload.meta,
                error: ''
            }
        case LINE_LIST_ERROR:
            return {
                ...state,
                loading: false,
                lineList: [],
                meta: [],
                error: action.payload.message
            }
        case LINE_DETAIL_REQUEST:
            return {
                ...state,
                detailLoading: true,
            }
        case LINE_DETAIL_SUCCESS:
            return {
                ...state,
                detailLoading: false,
                lineDetail: action.payload.lineDetail
            }
        case LINE_NEW_REQUEST:
            return {
                ...state,
                detailLoading: true,
                closeModal: false
            }
        case LINE_NEW_SUCCESS:
            return {
                ...state,
                detailLoading: false,
                closeModal: true
            }
        case LINE_UPDATE_REQUEST:
            return {
                ...state,
                detailLoading: true,
                closeModal: false
            }
        case LINE_UPDATE_SUCCESS:
            return {
                ...state,
                detailLoading: false,
                closeModal: true
            }
        case LINE_TRIGGER_HIGHLIGHT:
            return {
                ...state,
                triggerHighlight: action.payload,
                closeModal: false,
            }
        default: 
            return state;
    }
}

export default lineConfigListReducer;